var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConcertRock1StreamlineUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.439 9V5.25a1.5 1.5 0 0 1 3 0v10.5a5.167 5.167 0 0 1-1.5 3.75v3.75M11.439 9V2.25a1.5 1.5 0 1 0-3 0V13.5L6 11.548a1.538 1.538 0 0 0-2.242 2.055L8.75 19.5v3.75M14.439 9a1.5 1.5 0 1 0-3 0v3a1.5 1.5 0 0 0 3 0V9Zm3 0a1.5 1.5 0 1 0-3 0v3a1.5 1.5 0 0 0 3 0V9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcertRock1StreamlineUltimate);
export default __webpack_public_path__ + "static/media/Concert-Rock-1--Streamline-Ultimate.c7a2b70173f159ad3fbb35463f90bce5.svg";
export { ForwardRef as ReactComponent };